/**
 * Lightweight scroll-reveal: fades/slides elements in as they enter the
 * viewport. Opt in per element with `data-scroll-reveal`.
 */

const observer = new IntersectionObserver(
  (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    }
  },
  { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
);

function observeAll(root) {
  root.querySelectorAll('[data-scroll-reveal]').forEach((el) => observer.observe(el));
}

observeAll(document);

document.addEventListener('shopify:section:load', (event) => {
  if (event.target instanceof ParentNode) observeAll(event.target);
});
